"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourcePathError = exports.TargetPathError = exports.AutomaticPathsMatchesError = exports.linkMetaWithSpectra = void 0;
const get_1 = __importDefault(require("lodash/get"));
const prepareKey_1 = require("./prepareKey");
function linkMetaWithSpectra(options) {
    const { autolink = false, parseMetaFileResult, spectra } = options;
    let { source, target } = options;
    const targetValues = {};
    const { data, meta: { fields = [] }, } = parseMetaFileResult;
    if (!autolink) {
        if (target && !(0, get_1.default)(spectra[0], target)) {
            throw new TargetPathError(target);
        }
        if (source && !fields.includes(source)) {
            throw new SourcePathError(source);
        }
    }
    if (autolink) {
        for (const sourceField of fields) {
            if ((0, get_1.default)(spectra[0], sourceField, null)) {
                source = sourceField;
                target = sourceField;
                break;
            }
        }
    }
    const compareResult = {};
    const matches = {}; /** where the `key` is the spectra id and the `value` is the meta object  */
    if (source && target) {
        for (const spectrum of spectra) {
            const value = (0, get_1.default)(spectrum, target);
            if (['string', 'number'].includes(typeof value)) {
                const val = (0, prepareKey_1.prepareKey)(value);
                if (!targetValues[val]) {
                    targetValues[val] = [spectrum.id];
                }
                else {
                    targetValues[val].push(spectrum.id);
                }
            }
        }
        const sourceValues = {};
        let index = 0;
        for (const metaRow of data) {
            const sourceValue = (0, prepareKey_1.prepareKey)(metaRow[source]);
            if (targetValues[sourceValue]) {
                if (!sourceValues[sourceValue]) {
                    sourceValues[sourceValue] = [index];
                }
                else {
                    sourceValues[sourceValue].push(index);
                }
            }
            index++;
        }
        for (const key in sourceValues) {
            for (const index of sourceValues[key]) {
                const isDuplicated = sourceValues[key].length > 1;
                compareResult[index] = {
                    key,
                    isDuplicated,
                    spectraIDs: targetValues[key],
                };
                if (!isDuplicated && targetValues[key].length === 1) {
                    matches[targetValues[key][0]] = data[index];
                }
            }
        }
    }
    return { matches, compareResult };
}
exports.linkMetaWithSpectra = linkMetaWithSpectra;
class AutomaticPathsMatchesError extends Error {
    constructor() {
        super('No matching Field');
        this.name = 'AutomaticPathsMatchesError';
    }
}
exports.AutomaticPathsMatchesError = AutomaticPathsMatchesError;
class TargetPathError extends Error {
    constructor(fieldPath) {
        super(`Target field path [ ${fieldPath} ] is not exists`);
        this.name = 'TargetPathError';
    }
}
exports.TargetPathError = TargetPathError;
class SourcePathError extends Error {
    constructor(fieldPath) {
        super(`Source field path [ ${fieldPath} ] is not exists`);
        this.name = 'AutomaticPathsMatchesError';
    }
}
exports.SourcePathError = SourcePathError;
